import dataDisplayCtor from "./dataDisplayCtor";
import TooltipMerchant from "../../TooltipWithCopy";

const adminCtor = (props = {}) => dataDisplayCtor({...props, tooltipComponent: TooltipMerchant});

module.exports = adminCtor;
